<div role="main">
    <app-header></app-header>
    <div class="col-md-6 offset-md-1 d-flex align-items-center">
        <span class="text-white-ref ref">Reference ID</span>
        <span class="ref-id-no ms-2">{{service.referenceFileDetails.referenceId}}</span>
    </div>

    <div class="row link-container">
        <div class="col-md-auto offset-md-1 mt-3">
            <a class="btn btn-info-current w-40" *ngIf= "true">Contact Information</a>
        </div>
        <div class="col-md-auto mt-3">
            <a class="btn btn-info w-40" *ngIf="service.hasVisited('file-upload')" (click)="service.navigateTo('file-upload')">File Upload</a>
        </div>
        <div class="col-md-auto mt-3">
            <a class="btn btn-info w-40" *ngIf="service.hasVisited('review-files')" (click)="service.navigateTo('review-files')">Review & Submit Files</a>
        </div>
    </div>

    <div class="row">
        <div class="col-md-8 offset-md-1 mt-4 mb-3">
            <span class="file-download-err text-white-ref">Please enter the information below, we may need to contact you regarding
                the file download.</span>
        </div>
    </div>

    <form [formGroup]="referenceForm" (ngSubmit)="next()" class="referenceheader">
        <div class="col-md-3 offset-md-1">
            <div class="form-group mt-2 mb-2">
                <label class="text-white">Business/Organization Name</label> <span class="text-white-sub"> (Required)</span>
                <input type="text" class="form-control" id="business" placeholder="Enter your business name"
                    formControlName="businessName" name="businessName" maxlength="60">
            </div>
            <div class="form-group mt-2 mb-2">
                <label class="text-white">Contact Name</label> <span class="text-white-sub"> (Required)</span>
                <input type="text" class="form-control" id="contact-name" placeholder="Enter your first and last name"
                    formControlName="contactName" name="contactName" maxlength="60">
            </div>
            <div class="form-group mb-2">
                <label class="text-white">Phone Number & Extension</label> <span class="text-white-sub"> (Required)</span>
                <input type="text" class="form-control" id="contact-phone" placeholder="999-999-9999"
                    formControlName="contactPhone" name="contactPhone">
            </div>
            <div class="form-group mt-2 mb-2">
                <label class="text-white">Email</label> <span class="text-white-sub"> (Required)</span>
                <input type="text" class="form-control" id="contact-email" placeholder="example@example.com"
                    formControlName="contactEmail" name="contactEmail" maxlength="60"
                    (keyup)="onKeyUpEmailFormatEvent($event)">
                <!-- <div *ngIf="referenceForm.get('contactEmail')?.errors?.['invalidEmailDomain'] && referenceForm.get('contactEmail')?.touched"
                    class="text-danger">
                    Please enter a valid email ending with .com, .in, .us, .cz, .org, .net
                </div> -->
                
            </div>
        </div>
        
        <div *ngIf="isInvalidEmail" class="offset-md-1 mb-2">
            <span  class="text-danger">Please enter a valid email address, it must end with .com, .in, .us, .cz, .org, or .net.</span>
        </div>

        <div class="col-md-6 offset-md-1 pt-10">
            <div class="button-group">
                <button type="button" class="btn-clear" id="dashboardButton" (click)="close()">Cancel</button>
                <button type="submit" class="btn-enter" id="dashboardButton"
                [disabled]="referenceForm.invalid" [ngbTooltip]="referenceForm.invalid ? 'Please fill out the required fields to proceed' : ''" [tooltipClass]="'tooltip-disabled'" >
                {{ buttonText }}
                </button>
            </div>
        </div>
    </form>
    <app-footer></app-footer>
</div>